import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleWelcomeModal',
  props: {
    infoModalVisible: { type: Boolean, default: false }
  },
  emits: ['closeModal'],
  setup(__props: any, { emit }) {

const props = __props as { infoModalVisible: boolean };





const closeModal = () => {
    emit('closeModal');
};

return { __sfc: true,props, emit, closeModal }
}

})